import React, { useCallback, useState } from 'react'
import Link from 'next/link'
import { RecoverPasswordForm } from '../../forms'

// TODO: Better success state
const RecoverPasswordView: React.FC = () => {
  const [done, setDone] = useState(false)
  const handleSuccess = useCallback(() => {
    setDone(true)
  }, [])
  return (
    <div className={'w-full'}>
      {done && (
        <div className={'text-center py-6'}>
          <h3 className={'text-xl mb-2'}>Email sent!</h3>
          <p className={'text-gray-800 text-center'}>
            Check your email and open the link we sent to continue. Make sure to
            check your spam folder if you don&apos;t see the email.
          </p>
        </div>
      )}
      {!done && (
        <>
          <p className={'text-sm text-gray-800'}>
            Fill in your email below to request a new password. An email will be
            sent to the address below containing a link to verify your email
            address.
          </p>
          <div className={'mt-5 md:mt-6'}>
            <RecoverPasswordForm onSuccess={handleSuccess} />
          </div>
          <div className={'mt-3 text-center'}>
            <Link href={'/account/login'} prefetch={false}>
              <a className={'font-semibold text-gray-800 text-sm'}>Cancel</a>
            </Link>
          </div>
        </>
      )}
    </div>
  )
}

export default RecoverPasswordView
